<template>
  <layout-basic>
    <page-hero
      title="Real Businesses. Real Results."
      lead="See how organisations are transforming onboarding, compliance and employee development."
    />

    <section class="demo-video-section">
      <v-container style="max-width: 960px">
        <demo-video video-key="stories" />
      </v-container>
    </section>

    <!-- Steve, 18 Sep 2026: no "case study coming soon" placeholders; the
         genuine testimonials (the same carousel as Pricing) until the full
         sector case studies exist. The charity and renewal quotes that lived
         in the sector cards follow as a quote row so nothing is lost. -->
    <testimonial-carousel
      title="What our customers say"
      lead="Real feedback from organisations using IMPROVE today."
    />
    <quote-row :quotes="pageQuotes" />

    <standard-cta
      title="Could your business be next?"
      lead="Watch the 4-minute demo or experience IMPROVE for yourself."
    />
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import PageHero from '@/components/marketing/PageHero.vue';
import StandardCta from '@/components/marketing/StandardCta.vue';
import DemoVideo from '@/components/DemoVideo.vue';
import TestimonialCarousel from '@/components/marketing/TestimonialCarousel.vue';
import QuoteRow from '@/components/marketing/QuoteRow.vue';
import { marketingPageMeta } from '@/utils/marketingPage';
import {
  TRILOGY_RENEWED,
  CHARITY_VALUE_FOR_MONEY,
  CHARITY_LEARNING_PATHWAYS,
} from '@/data/testimonials';

export default {
  name: 'CustomerStories',
  components: {
    LayoutBasic,
    PageHero,
    StandardCta,
    DemoVideo,
    TestimonialCarousel,
    QuoteRow,
  },
  metaInfo() {
    return marketingPageMeta({
      title: 'Real Businesses. Real Results. | IMPROVE',
      description:
        'See how organisations are transforming onboarding, compliance and employee development with IMPROVE.',
      path: '/customer-stories',
    });
  },
  data() {
    return {
      // The two charity quotes from Steve's 16 Sep brief were headed "Charity
      // Sector Page"; there are no sector pages and he wants no new ones, so
      // they sit under the carousel here. Trilogy's renewal quote likewise.
      pageQuotes: [CHARITY_VALUE_FOR_MONEY, CHARITY_LEARNING_PATHWAYS, TRILOGY_RENEWED],
    };
  },
};
</script>
